// cleanup_convert_to_typescript_file_ALERTS

/* istanbul ignore file */
import { createUseStyles } from '@glu/theming';

const styles = ({ spacing: { unit } }) => ({
  outer: {
    overflowX: 'auto'
  },
  table: {
    width: '100%',
    overflow: 'scroll',
    backgroundColor: 'transparent',
    border: 'none',
    borderCollapse: 'collapse',
    minWidth: unit * 100,
    '& thead': {
      fontWeight: 'bold'
    },
    '& td': {
      padding: `0 ${unit * 3}px`
    }
  }
});

export default createUseStyles(styles);
